<template>
  <div id="animate-progress" class="progress-outer" :style="`width: ${width};`">
    <div class="progress-inner" :style="`height: ${height}; background-color: ${barColor}`">
      <div class="progress-bg" :style="`width: ${value}%; height: ${height}; background-color: ${color}; ${customStyle}`">
      </div>
    </div>
    <div class="progress-value">{{ value }}%</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
const Progress = defineComponent({
  props: {
    value: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '6px'
    },
    customStyle: {
      default: ''
    },
    barColor: {
      type: String,
      default: '#f5f5f5'
    },
    color: {
      type: String,
      default: '#16C986'
    }
  }
})
export default Progress
</script>
<style lang="less" scoped>
  .progress-outer{
    display: flex;
    align-items: center;
    .progress-value{
      font-size: 12px;
      line-height: 17px;
      margin-inline-start: 10px;
      font-weight: 600;
    }
    .progress-inner {
      flex: 1;
      border-radius: 100px;
      overflow: hidden;
      .progress-bg {
        border-radius: 100px;
      }
    }
  }
</style>
